export default __webpack_public_path__ + "static/media/global-b.fce3d2a5.png";